import * as React from 'react'
import { Alert } from 'antd'
import { FC } from 'react'

export type FormAlertProps = {
  msg: string
  type: 'info' | 'success' | 'error' | 'warning'
}

const FormAlert: FC<FormAlertProps> = ({ msg, type = 'info' }) => {
  if (!msg) return null

  return <Alert style={{ marginBottom: 10 }} message={msg} type={type} showIcon />
}

export default FormAlert
